/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import set from 'lodash/set';
import { makeAsyncAction } from 'ui-permit/shared-components/utils/async';
import {
    FETCH_PERMIT,
    FETCH_RECAREA,
    CLEAR_VALIDATION_ERROR,
    SET_VALIDATION_ERROR,
    DISPLAY_UI_VALIDATIONS,
    INPROGRESS_UPDATE_RESERVATION,
} from '../constants/actions';
import * as api from '../api';

export const fetchPermit = makeAsyncAction(
    FETCH_PERMIT,
    (id) => () => api.fetchPermit(id),
    'payload'
);
export const fetchRecarea = makeAsyncAction(
    FETCH_RECAREA,
    (id) => () => api.fetchRecarea(id),
    'results'
);

export function formValidationChange(path, error) {
    return {
        type: SET_VALIDATION_ERROR,
        payload: { path, error },
    };
}

export function setDisplayValidationErrors(shouldDisplay = true) {
    return (dispatch) =>
        dispatch({
            type: DISPLAY_UI_VALIDATIONS,
            payload: { shouldDisplay },
        });
}

export function clearTempValidations(id) {
    return (dispatch) => {
        dispatch({
            type: CLEAR_VALIDATION_ERROR,
            payload: { id },
        });
    };
}

export const updatePendingReservation = (_, path, value) => {
    return (dispatch, getState) => {
        const { reservation } = getState().huntingpermit;
        const { data } = { ...reservation };
        const payload = set(data, path, value);
        dispatch({ type: `${INPROGRESS_UPDATE_RESERVATION}_SUCCESS`, payload });
    };
};
